
import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Link,
  Outlet,
} from "react-router-dom";
import Content from './pages/Content'
import AboutUs from './pages/AboutUs'
import Home from './pages/LandingPage'; 
import ShortStories from "./pages/ShortStories";
import MovieReviews from "./pages/MovieReviews";
import Articlebasic from "./pages/content/Articlebasic";
import MV from "./pages/content/Modernvanvas"
import Articles from "./pages/Articles";
import Bumble from "./pages/content/bumble";
import Mysore from "./pages/content/mysore";
import Mumbai from "./pages/content/Mumbai";
import Jawaan from "./pages/content/jawaan";
import Khushi from "./pages/content/khushi";
import Bumble2 from "./pages/content/bumble2"
import Sexed from "./pages/content/sexed";
import Sapta from "./pages/content/sapta";
import Jaane from "./pages/content/Jaanejaan";
import Khu from "./pages/content/Khufiya";
import OMG2 from "./pages/content/OMG2";
import FS from "./pages/content/Firstsight";
import Hard from "./pages/content/Hardfe";
import Rora from './pages/content/Rora'
import Ordi from "./pages/content/ordinary"
import Volun from "./pages/content/Volun";
import Kissing from "./pages/content/kissingbooth";
import Feminism from "./pages/content/feminism";
import Questions from "./pages/content/questions";
import Mathew from "./pages/content/Mathew"
import Anxiety from "./pages/content/anxiety";
import Phaseshift from "./pages/content/phaseshift";
import Journal from "./pages/content/journal";
import Ram from "./pages/content/Ram";
const App = () => {
  return (
    <Router>
    <Routes>
    <Route path="/" element={<Home />} />
    <Route path="/aboutus" element={<AboutUs />} />
    <Route path="/content" element={<Content/>} />
    <Route path="/articles" element={<Articles />} />
    <Route path="/shortstories" element={<ShortStories />} />
    <Route path="/Moviereviews" element={<MovieReviews />} />
    <Route path="/ninhaB_VS_nanhaB" element={<Articlebasic />} />
    <Route path="/modernvanvas" element={<MV />} />
    <Route path='/bumble' element={<Bumble/>}/>
    <Route path='/mysore' element={<Mysore/>}/>
    <Route path='/mumbai' element={<Mumbai/>}/>
    <Route path='/jawan' element={<Jawaan/>}/>
    <Route path='/khushi' element={<Khushi/>}/>
    <Route path='/bumble2' element={<Bumble2/>}/>
    <Route path='/sexed' element={<Sexed/>}/>
    <Route path='/firstsight' element={<FS/>}/>
    <Route path='/sapta' element={<Sapta/>}/>
    <Route path='/jaane' element={<Jaane/>}/>
    <Route path='/khufiya' element={<Khu/>}/>
    <Route path='/omg2' element={<OMG2/>}/>
    <Route path='/nohardfe' element={<Hard/>}/>
    <Route path='/rockyrani' element={<Rora/>}/>
    <Route path='/ordinary' element={<Ordi/>}/>
    <Route path='/volun' element={<Volun/>}/>
    <Route path='/kissing' element={<Kissing/>}/>
    <Route path='/feminism' element={<Feminism/>}/>
    <Route path='/questions' element={<Questions/>}/>
    <Route path='/mathew' element={<Mathew/>}/>
    <Route path='/anxiety' element={<Anxiety/>}/>
    <Route path='/phaseshift' element={<Phaseshift/>}/>
    <Route path='/journal' element={<Journal/>}/>
    <Route path='/ram' element={<Ram/>}/>
    </Routes>
    </Router>
  );
};

export default App;